import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { Lock, Mail, LogIn, Home } from "lucide-react";
import { local } from "../lib/storage";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post("/auth/login", { email, password });
      local.set("theater_token", res.data.token);
      local.set("theater_email", res.data.email);
      toast.success("مرحباً بك في لوحة التحكم");
      nav("/admin");
    } catch (e) {
      toast.error(e.response?.data?.detail || "فشل تسجيل الدخول");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen stage-spotlight flex items-center justify-center p-4">
      <div className="w-full max-w-md theater-card rounded-2xl p-8 gold-glow">
        <div className="text-center mb-8">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#7A2E2A] to-[#3d1614] border border-[#F0E8DB]/60 flex items-center justify-center text-[#F0E8DB] text-2xl font-serif-en font-bold mx-auto mb-4">T</div>
          <h1 className="text-2xl font-semibold text-[#F0E8DB]">لوحة تحكم نادي المسرح</h1>
          <p className="text-[#A89A88] text-sm mt-2">تسجيل الدخول للإدارة</p>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div className="relative">
            <Mail className="absolute right-3 top-3.5 text-[#BFB3A0]" size={16} />
            <input
              data-testid="admin-login-email-input"
              type="email"
              required
              className="w-full input-theater rounded-lg pr-10 pl-4 py-3 text-sm"
              placeholder="البريد الإلكتروني"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="relative">
            <Lock className="absolute right-3 top-3.5 text-[#BFB3A0]" size={16} />
            <input
              data-testid="admin-login-password-input"
              type="password"
              required
              className="w-full input-theater rounded-lg pr-10 pl-4 py-3 text-sm"
              placeholder="كلمة المرور"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button
            data-testid="admin-login-submit-button"
            type="submit"
            disabled={loading}
            className="btn-gold rounded-full w-full py-3 flex items-center justify-center gap-2 disabled:opacity-60"
          >
            <LogIn size={16} /> {loading ? "جاري الدخول..." : "دخول"}
          </button>
        </form>
        <a href="/" data-testid="back-home-link" className="flex items-center justify-center gap-1 text-[#BFB3A0] hover:text-[#F0E8DB] text-sm mt-6">
          <Home size={14} /> العودة إلى الموقع
        </a>
      </div>
    </div>
  );
}
